import React, { Component } from "react";
import PropTypes from "prop-types";
import MediaQuery from 'react-responsive';
import Icon from '../Icon/Icon';
import "./ProgreesNotification.css";
import { Link, withRouter } from 'react-router-dom';
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";

/**
 * @desc ProgreesNotification
 * @param props
 * @return null
 */

class ProgreesNotification extends Component {

  state = {
    show: null
  }

  componentDidUpdate() {
    if(localStorage.getItem('showNotification') && this.state.show == null){
      this.setState({show: localStorage.getItem('showNotification')});
    }
  }

  componentDidMount() {
    if(this.props.handleMobileView){
      if(localStorage.getItem('showNotification') && this.state.show == null){
        this.setState({show: localStorage.getItem('showNotification')});
      }
    }
  }

  
  render(){
    const { className } = this.props;

    return(
      <div className= {"progress-notification" + className}>
        {this.state.show?<div className="progress-notification-container">
        <div className="progress-notification-info-icon"> 
        <Icon 
          icon="progress-notification-info-icon"
          className="info"
        ></Icon>           
        </div>
        <div className="progress-notification-info-msg">
          <p className="info-msg">
          <MediaQuery query="(min-device-width: 800px)">
           We see you’ve started to progress candidates. <Link to={"/interviews"}>
                <span>Click here</span></Link> to start scheduling interviews!
          </MediaQuery>
          <MediaQuery query="(max-device-width: 799px)">
           We see you’ve started to progress candidates. <br/><Link to={"/interviews"}>
                <span>Click here</span></Link> to start scheduling interviews!
          </MediaQuery>
          </p>          
        </div>
        <div className="progress-notification-close-icon" onClick={this.props.handleCloseNotification}> 
        <Icon 
          icon="progress-notification-close-icon"
          className="close-icon"
          color="red"
        ></Icon>           
        </div>
      </div>:""}
    </div>
    )
  }
}

export default ProgreesNotification;



// WEBPACK FOOTER //
// ./src/components/UI/ProgreesNotification/ProgreesNotification.js